export enum SettingsParentSection {

    TASKS_PROJECTS,
    PRODUCTIVITY,
    AUTOMATIONS,
    COMPANY_USERS,
    ACCESS,
    TIME,
    FINANCE,
    CRM,
    VIEWS,
    SYSTEM,
    ORGANIZATION,
    INTEGRATIONS,
    API
}